import { BlogSection } from '@/types/blog';

export const haben_oder_sein: BlogSection = {
  id: 'haben-oder-sein',
  title: 'Die zwei Modi des Existierens',
  content: `
    <h3 class="text-2xl font-bold text-joerg-800 dark:text-joerg-100 mt-8 mb-4">Haben-Modus: Die Logik des Besitzes</h3>
    
    <p>Im Haben-Modus ist die Welt ein Objekt. Etwas, das ich besitzen, kontrollieren, akkumulieren kann.</p>

    <p><strong>Beispiele:</strong></p>
    <ul class="list-disc pl-6 space-y-2 my-4">
      <li><strong>Liebe:</strong> „Ich habe einen Partner." (Besitz)</li>
      <li><strong>Wissen:</strong> „Ich habe einen Abschluss." (Zertifikat, nicht Verstehen)</li>
      <li><strong>Business:</strong> „Ich habe 10.000 Follower." (Metrik, nicht Resonanz)</li>
      <li><strong>Glück:</strong> „Ich muss Glück haben." (Zustand, den ich erwerben muss)</li>
    </ul>

    <p><strong>Problem:</strong></p>
    <ul class="list-disc pl-6 space-y-2 my-4">
      <li><strong>Haben = fragil</strong> (was ich habe, kann ich verlieren)</li>
      <li><strong>Haben = nie genug</strong> (ein Partner, ein Abschluss, 10.000 Follower – und dann?)</li>
      <li><strong>Haben = Angst</strong> (vor Verlust, Konkurrenz, Vergleich)</li>
    </ul>

    <div class="bg-gradient-to-br from-sage-50 to-joerg-50 dark:from-sage-900 dark:to-joerg-900 p-6 rounded-lg border border-sage-200 dark:border-sage-800 my-6">
      <p class="text-joerg-700 dark:text-joerg-300 italic">
        <strong>Fromm:</strong> „Im Haben-Modus gibt es keine lebendige Beziehung zwischen mir und dem, was ich habe. Es und ich sind getrennt geworden."
      </p>
    </div>

    <h3 class="text-2xl font-bold text-joerg-800 dark:text-joerg-100 mt-12 mb-4">Sein-Modus: Die Logik der Existenz</h3>
    
    <p>Im Sein-Modus ist die Welt ein Prozess. Etwas, das ich erlebe, praktiziere, <em>bin</em>.</p>

    <p><strong>Beispiele:</strong></p>
    <ul class="list-disc pl-6 space-y-2 my-4">
      <li><strong>Liebe:</strong> „Ich praktiziere Liebe." (Haltung, nicht Besitz)</li>
      <li><strong>Wissen:</strong> „Ich lerne." (Prozess, nicht Zertifikat)</li>
      <li><strong>Business:</strong> „Ich schaffe Resonanz." (Wirkung, nicht Metrik)</li>
      <li><strong>Glück:</strong> „Ich bin im Einklang." (Zustand, der entsteht, nicht erworben wird)</li>
    </ul>

    <p><strong>Vorteil:</strong></p>
    <ul class="list-disc pl-6 space-y-2 my-4">
      <li><strong>Sein = resilient</strong> (was ich bin, kann mir niemand nehmen)</li>
      <li><strong>Sein = erfüllend</strong> (der Prozess ist das Ziel)</li>
      <li><strong>Sein = angstfrei</strong> (kein Verlust möglich, weil nichts zu verlieren)</li>
    </ul>

    <div class="bg-gradient-to-br from-sage-50 to-joerg-50 dark:from-sage-900 dark:to-joerg-900 p-6 rounded-lg border border-sage-200 dark:border-sage-800 my-6">
      <p class="text-joerg-700 dark:text-joerg-300 italic">
        <strong>Fromm:</strong> „Im Sein-Modus ist mein Bezug zur Welt lebendig und echt."
      </p>
    </div>
  `
};
